import styled from "styled-components"
import CssBaseline from "@material-ui/core/CssBaseline"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { MainContainer } from '../MainContainer'
import { WatcherMainContainer } from '../WatcherMainContainer'
import { SignerBatchMainContainer } from "../SignerBatchMainContainer"
import { RedirectContainer } from '../RedirectContainer'
import { NotFoundPage } from '../NotFoundPage'
import { UnsupportedDevicePage } from '../UnsupportedDevicePage'
import { defaultThemeSettings } from '../../utils/utils'
import { ThemeProvider } from "src/contexts/ThemeContext"
import { useState, useCallback, useRef, useMemo } from "react"
import { setDatadogAction } from "../../services/datadog"

export const MainRouter = (props) => {
    
    const { isInvalidBrowser, isInvalidOS } = props;
    const [signMetadata, setSignMetadata] = useState({});
    const hasReceivedMetadata = useRef(false);

    const setSignMetadataCallback = useCallback((metadata) => {
        if (!hasReceivedMetadata.current) {
            hasReceivedMetadata.current = true;
            setDatadogAction('Sign Metadata information fetched', metadata);
            setSignMetadata((prev) => ({...prev, ...metadata}));
        }
    }, []);

    const router = useMemo(() => createBrowserRouter([
        {
            path: "/s/:signerHash",
            element: <MainContainer setSignMetadata={setSignMetadataCallback}/>
        },
        {
            path: "/r/:signerHash",
            element: <RedirectContainer setSignMetadata={setSignMetadataCallback}/>
        },
        {
            path: "/sb/:signerBatchHash",
            element: <SignerBatchMainContainer />
        },
        {
            path: "/w/:watcherHash",
            element: <WatcherMainContainer />
        },
        {
            path: "*",
            element: <NotFoundPage clientThemeSettings={defaultThemeSettings} />
        }
    ]), [setSignMetadataCallback])

    const Main = styled.main`
        height: 100vh;
        height: 100dvh;
        width: 100vw;
        background-color: #f8f8f8;
        display: flex;
        justify-content: center;
        align-items: center;
    `;

    return (
        <div>
            <ThemeProvider>
                <CssBaseline />
                <Main>
                    {signMetadata?.face && (isInvalidBrowser || isInvalidOS) ? <UnsupportedDevicePage isInvalidBrowser={isInvalidBrowser} isInvalidOS={isInvalidOS} signMetadata={signMetadata} /> : <RouterProvider router={router} />}
                </Main>
            </ThemeProvider>
        </div>
    )
}
